export type PostTagCategory = "artist" | "character" | "copyright" | "general" | "meta"

const KINDS: Array<[string, Exclude<PostTagCategory, "general">]> = [
  ["tag_string_artist", "artist"],
  ["tag_string_character", "character"],
  ["tag_string_copyright", "copyright"],
  ["tag_string_meta", "meta"],
]

/**
 * Tag types from a Danbooru-style post, which arrives with its tags already split by type (`tag_string_artist` and so
 * on). Returns undefined for any other source's post, so those keep guessing from the tag name. `tags` is the post's
 * full tag list; anything not named in one of the typed lists is general.
 */
export function danbooruTagCategories(
  raw: Record<string, unknown> | null | undefined,
  tags: string[],
): Record<string, PostTagCategory> | undefined {
  if (!raw || !KINDS.some(([field]) => typeof raw[field] === "string")) return undefined
  const categories: Record<string, PostTagCategory> = {}
  for (const tag of tags) categories[tag] = "general"
  for (const [field, category] of KINDS) {
    for (const tag of String(raw[field] ?? "").split(" ")) if (tag) categories[tag] = category
  }
  return categories
}
